document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.header_btn');
  if (!btn) return;

  btn.textContent = 'GET MOMENTUM';

  const FALLBACK_ANCHOR = '#shopify-section-template--22695511883994__lp_buybox_gAVHdK';
  const buyboxOnPage = document.querySelector('[id^="shopify-section-"][id$="lp_buybox_gAVHdK"]');
  const anchor = buyboxOnPage ? ('#' + buyboxOnPage.id) : FALLBACK_ANCHOR;

  btn.href = '/' + window.location.search + anchor;
});


document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero_lp');
  const marquee = document.querySelector('.hero_lp_marquee');

  if (!hero || !marquee) return;

  const toggleHeaderGlass = () => {
    const wasStuck = marquee.classList.contains('hero_lp_marquee_stuck_bottom');

    if (wasStuck) {
      marquee.classList.remove('hero_lp_marquee_stuck_bottom');
    }

    const heroBottom = hero.getBoundingClientRect().bottom;
    const marqueeBottom = marquee.getBoundingClientRect().bottom;
    const shouldStick = heroBottom <= marqueeBottom;

    document.documentElement.classList.toggle('lp-header-glass-active', shouldStick);
    document.documentElement.classList.toggle('lp-header-green-transition', shouldStick);

    if (shouldStick) {
      marquee.classList.add('hero_lp_marquee_stuck_bottom');
    }
  };

  toggleHeaderGlass();

  window.addEventListener('scroll', toggleHeaderGlass, { passive: true });
  window.addEventListener('resize', toggleHeaderGlass);
});

document.addEventListener('DOMContentLoaded', () => {
  const ingredientsLinks = Array.from(
    document.querySelectorAll('a')
  ).filter((link) => link.textContent.trim() === 'Ingredients');

  ingredientsLinks.forEach((link) => {
    link.href = '#ingredients';
  });
});